export default __webpack_public_path__ + "static/media/gps.8b2f2da6.svg";